window.Branch.cart.fetchUpdateCart = function(){
    $(function() {
      let cartContents = {};
      let sideCartElement = document.querySelector('#side-cart');
      let enable_shopify_installments_banner = sideCartElement.getAttribute('data-enable-shopify-installments-banner') == 'true';
      let enable_incompatible_mismatched_products_warning = sideCartElement.getAttribute('data-enable-incompatible-mismatched-products-warning') == 'true';
      let allow_free_shipping = sideCartElement.getAttribute('data-allow-free-shipping') == 'true';
      fetch('/cart.js')
      .then(response => response.json())
      .then((data) => {
        cartContents = data.items;
            let price = window.Branch.functions.updateSideCartPricing('side-cart');
              
           if(enable_shopify_installments_banner){
              window.Branch.installmentsBanner.initInstallmentsBanner('side-cart', price);
           }
           if( enable_incompatible_mismatched_products_warning){
              window.Branch.cart.productWarnings(cartContents, 'side-cart');
           }
         });

      var itemsCount = 0,
      bundlesCount = 0,
      hideShipping = false;
      $('#side-cart .quantity-box input[type=number]').each(function(){
        itemsCount += parseInt($(this).val());
      });
      document.querySelectorAll('#side-cart [data-cart-discount]').forEach(function(e){
        if (e.getAttribute('data-cart-discount').includes('Bundle')) {
          bundlesCount ++;          
        }
        /*if ($(this).value.indexOf('Bundle') >= 0)
        bundlesCount ++;*/
      });
      document.querySelectorAll('#side-cart [data-b2b-shipping]').forEach(function(e){
        if (e.getAttribute('data-cart-discount').includes('Bundle')) {
          bundlesCount ++;          
        }
      });
      /*$.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        cache: false
      }).done(function( data ) {
          console.table( data.items );
      });*/
      $('.header .cart-wrap .count').html(itemsCount);

      if(itemsCount > 0){
        $('.header .cart-wrap .count-wrap').addClass('active');
        if( allow_free_shipping){
        $('.cart-free-shipping').removeClass('hidden');
        //$('.cart-free-shipping .check rect').removeClass('inactive');
        $('.cart-free-shipping p').removeClass('inactive');
        if(itemsCount === 2 && bundlesCount == 2) {
          $('[data-shipping-bar-line]').addClass('full-width')
          
        }
        else if(itemsCount === 1) {
          $('[data-shipping-bar-line]').addClass('full-width')
          
        }
    }
      }else{
        $('.header .cart-wrap .count-wrap').removeClass('active');
      }
      function updateCart(){
        $('#loading-overlay').show();
        let data12 = $('#side-cart form').serialize();
        var cartData = {updates: {}, attributes: {} };

        if(document.querySelector('#side-cart form') && document.querySelectorAll('#side-cart form input[data-item-type="product"][data-quantity-input]').length > 0){
          document.querySelectorAll('#side-cart form input[data-item-type="product"][data-quantity-input]').forEach((quantityInput) => {
            if(quantityInput.hasAttribute('data-item-combo-product')){
              let comboProducts = JSON.parse(quantityInput.getAttribute('data-item-combo-product'));
              let comboProductQuantity = 0;
              comboProducts.forEach((comboProduct) => {
                if(document.querySelectorAll(`#side-cart form input[data-item-type="product"][data-quantity-input][data-item-handle="${comboProduct}"]`).length > 0){
                  document.querySelectorAll(`#side-cart form input[data-item-type="product"][data-quantity-input][data-item-handle="${comboProduct}"]`).forEach((quantityComboInput) => {
                  comboProductQuantity = comboProductQuantity + parseInt(quantityComboInput.value);
                  });
                }
              });
              if(parseInt(quantityInput.value) > comboProductQuantity){
                cartData.updates[ `${quantityInput.getAttribute('data-key')}` ] = `${comboProductQuantity}`;
              } else {
                cartData.updates[ `${quantityInput.getAttribute('data-key')}` ] = `${parseInt(quantityInput.value)}`;
              }
            } else {
              cartData.updates[ `${quantityInput.getAttribute('data-key')}` ] = `${parseInt(quantityInput.value)}`;
            } 
          })
        }

        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: cartData,
          dataType: 'json'
        }).fail(function(){console.log('error');}).done(function(response){
          // Check if we need to apply the auto discount code based on cart quantity
          const discountCodeLimit = window.AUTO_DISCOUNT_CODE_QUANTITY_LIMIT || 0;
          const discountCode = window.AUTO_DISCOUNT_CODE || '';
          if (discountCodeLimit > 0 && discountCode) {
            const totalCartQuantity = response.item_count || response.items.reduce((sum, item) => sum + item.quantity, 0);
            const itemNeedsSplit = response.items.some(item => item.quantity > discountCodeLimit);

            // Reset the split flag if quantity is back at or below limit
            if (totalCartQuantity <= discountCodeLimit) {
              window._discountSplitApplied = false;
            }

            // If cart quantity exceeds limit AND there's an item that needs splitting AND we haven't already applied the split
            if (totalCartQuantity > discountCodeLimit && itemNeedsSplit && !window._discountSplitApplied) {
              window._discountSplitApplied = true;
              applyDiscountCodeToSplitItems(function() {
                window.Branch.cart.updateCartDesc(true);
              });
              return;
            }
          }

          // Dispatch cart:updated event for auto-discount-code.js to re-check quantity
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
          addToCartSuccess();
          $('#add-cart-overlay').fadeOut();
        });

        /* If bundle-builder open, check that contents still match */
        if(document.querySelector('body.template-page-bundles')){
           window.Branch.bundle.handleCartQuantityChange() 
        }
      }

      $('#side-cart button.remove').click(function(e){
        e.preventDefault();
        removeClydeCart(e);
        $(this).closest('.item').find('input[type=number]').val(0);
        updateCart();


         // Extend - Dispatch sidecart on qty change
         //if(Extend && Extend.integration){
          //window.dispatchEvent(Extend.integration.CustomEvent("refreshAjaxSideCart"))
        //}
         // Extend - End code

        return false;
      });

      $('#side-cart input[type=number]').change(function(e){
        /*
        if($(this).val() == 0 ){
         removeClydeCart(e);
        }else{
         updateClydeCart(e);
        }
        */
        updateClydeCart(e);
        updateCart();

        // Extend - Dispatch sidecart on qty change
        //if(Extend && Extend.integration){
          //window.dispatchEvent(Extend.integration.CustomEvent("refreshAjaxSideCart"))
        //}
        // Extend - End code
      });
      
      $(document).on('keydown', function(e){
        if (e.which == 27) { //Exit
          if($('#side-cart').hasClass('open')){
            e.preventDefault();
            hideSideCart();
            return false;
          }
        }
      });

      window.Branch.cart.updateFreeShippingThreshold(shippingThresholdTest);
      window.Branch.addons.sideCartAddonsInit();
    });
  }


  window.Branch.cart.updateCartCount = function(itemsCount){
      $(function() {
        $('.header .cart-wrap .count').html(itemsCount);
        if(itemsCount > 0){
          $('.header .cart-wrap .count-wrap').addClass('active');
        }else{
          $('.header .cart-wrap .count-wrap').removeClass('active');
        }
      })
    }

    window.Branch.cart.updateFreeShippingThreshold = function(newThreshold) {
      // console.log('updateFreeShippingThreshold');
      let freeShippingUpdated = document.querySelector('#side-cart .cart-free-shipping') && document.querySelector('#side-cart .cart-free-shipping').getAttribute('data-updated') == 'true';
        document.querySelector('#side-cart .cart-free-shipping').setAttribute('data-updated', 'true');
            var thresholdValue = (typeof newThreshold !== 'undefined') ? newThreshold : window.Branch.cart.shipThresholdData.ship_threshold;
            $.getJSON('/cart.js', function(cart) { 
                var totalPriceInDollars = cart.total_price / 100;
                var freeShipThreshold = thresholdValue;
                var widthPercentage;

                function returnFinalInnerHTMLSavings(innerHTMLSavings, shipThresholdData, thresholdMet) {
                  let finalInnerHTMLSavings = innerHTMLSavings;
                  if (shipThresholdData.enable_gift_with_bundle_prompt && thresholdMet) {
                    if(shipThresholdData.standard_bundle_present && shipThresholdData.gift_present){
                      // Gift claimed - make bar fully complete (100%)
                      const shippingBarLine = document.querySelector('[data-shipping-bar-line]');
                      if (shippingBarLine) {
                        shippingBarLine.classList.add('full-width');
                        shippingBarLine.classList.remove('full');
                        // Override the 75% width from CSS to make it 100%
                        shippingBarLine.style.setProperty('width', '100%', 'important');
                      }
                      // Keep gift icon in original colors (dark background, white strokes)
                      const giftIcon = document.querySelector('.gift-with-bundle-prompt-icon-2');
                      if (giftIcon) {
                        // Ensure original colors are maintained
                        const circlePath = giftIcon.querySelector('circle');
                        const strokePaths = giftIcon.querySelectorAll('path');
                        if (circlePath) {
                          circlePath.setAttribute('fill', '#314438'); // Dark green background
                        }
                        strokePaths.forEach(path => {
                          path.setAttribute('stroke', '#ffffff'); // White strokes
                        });
                      }
                      finalInnerHTMLSavings = `${shipThresholdData.gift_with_bundle_prompt_post_unlock_message.replace('<p>', '<p id="ship-msg-savings" style="margin-top: 16px;">')}`
                    } else if(shipThresholdData.standard_bundle_present && !shipThresholdData.gift_present) {
                      // Bundle present but gift not claimed - make bar 100% and update gift icon
                      const shippingBarLine = document.querySelector('[data-shipping-bar-line]');
                      if (shippingBarLine) {
                        shippingBarLine.classList.add('full-width');
                        shippingBarLine.classList.remove('full');
                        // Override the 75% width from CSS to make it 100%
                        shippingBarLine.style.setProperty('width', '100%', 'important');
                      }
                      // Keep gift icon in original colors (dark background, white strokes)
                      const giftIcon = document.querySelector('.gift-with-bundle-prompt-icon-2');
                      if (giftIcon) {
                        // Ensure original colors are maintained
                        const circlePath = giftIcon.querySelector('circle');
                        const strokePaths = giftIcon.querySelectorAll('path');
                        if (circlePath) {
                          circlePath.setAttribute('fill', '#314438'); // Dark green background
                        }
                        strokePaths.forEach(path => {
                          path.setAttribute('stroke', '#ffffff'); // White strokes
                        });
                      }
                      finalInnerHTMLSavings = `${shipThresholdData.gift_with_bundle_prompt_unlocked_message.replace('#product_title#', shipThresholdData.gift_with_bundle_product_title).replace('<p>', '<p id="ship-msg-savings" style="margin-top: 16px;">').replace('<\/p>', '</p>').replace('</p>', `<br><button class="quick-view-link" style="text-decoration: underline; padding-top: 8px; color: var(--primary-green);" data-url="/products/${shipThresholdData.gift_with_bundle_product_handle}?view=quick-view">${shipThresholdData.gift_with_bundle_prompt_atc_text}</button>`)}`
                    } else {
                      // When showing the pre-unlock bundle message, show primary message with proper spacing
                      const primaryMsg = document.querySelector('.cart-free-shipping p');
                      if (primaryMsg) {
                        primaryMsg.style.display = 'block';
                        primaryMsg.style.margin = '16px 0 0';
                      }
                      finalInnerHTMLSavings = `${shipThresholdData.gift_with_bundle_prompt_pre_unlock_message.replace('<p>', '<p id="ship-msg-savings" style="margin-top: 8px;">')}`
                    }
                  }

                  return finalInnerHTMLSavings;
                }

                let totalSavings = document.querySelector('#side-cart .foot .cart-subtotal-saving-message') && document.querySelector('#side-cart .foot .cart-subtotal-saving-message').getAttribute('data-total-discount') ? parseInt(document.querySelector('#side-cart .foot .cart-subtotal-saving-message').getAttribute('data-total-discount')) : 0;

                if(document.querySelector('.cart-free-shipping p#ship-msg-savings')){
                  document.querySelector('.cart-free-shipping p#ship-msg-savings').remove();
                }

                if (totalPriceInDollars >= freeShipThreshold) {
                    let innerHTML = window.Branch.cart.shipThresholdData.free_ship_msg;
                    let innerHTMLSavings = '<p id="ship-msg-savings">' + innerHTML + '</p>';
                    if(totalSavings > 0){
                      innerHTMLSavings = '<p id="ship-msg-savings">' +  window.Branch.cart.shipThresholdData.free_ship_msg_with_savings.replaceAll('#amount#', parseInt((totalSavings / 100)))  + "</p>"
                    }

                    let finalInnerHTMLSavings = returnFinalInnerHTMLSavings(innerHTMLSavings, window.Branch.cart.shipThresholdData, true);
                    document.querySelector('.cart-free-shipping p').innerHTML = innerHTML;
                    document.querySelector('.cart-free-shipping').insertAdjacentHTML('beforeend', finalInnerHTMLSavings);
                    $('.cart-free-shipping .check').addClass('check-full');
                    widthPercentage = 100;
                } else {
                    var calCartTotal = freeShipThreshold - totalPriceInDollars;
                    $('.cart-free-shipping .check').css('display', 'none');
                    
                    let innerHTML = "You are <b>$" + calCartTotal.toFixed(2) + "</b> away from free shipping.";
                    let innerHTMLSavings = '<p id="ship-msg-savings">' + innerHTML + '</p>';
                    if(totalSavings > 0){
                      innerHTMLSavings = '<p id="ship-msg-savings">' + "You saved $" + (totalSavings / 100).toFixed(2) + " and  are <b>$" + calCartTotal.toFixed(2) + "</b> away from free shipping." + "</p>"
                    }

                    let finalInnerHTMLSavings = returnFinalInnerHTMLSavings(innerHTMLSavings, window.Branch.cart.shipThresholdData, false);
                    document.querySelector('.cart-free-shipping p').innerHTML = innerHTML;
                    document.querySelector('.cart-free-shipping').insertAdjacentHTML('beforeend', finalInnerHTMLSavings);
                    widthPercentage = (totalPriceInDollars / freeShipThreshold) * 100;
                }

                /* Update utility bar */

                if(window.Branch.cart.shipThresholdData.bundle_present){

                let utilityBar = document.querySelector('#header .utility-bar');
                if(utilityBar){
                let bundleUpdateAlreadyCompleted = utilityBar.getAttribute('data-bundle-update-completed') == 'true';
                
                  if(bundleUpdateAlreadyCompleted != true && utilityBar.getAttribute('data-display-bundle-message') == 'true'){
                    let currentMessagesCount = utilityBar.getAttribute('data-messages-count') ? parseInt(utilityBar.getAttribute('data-messages-count')) : 0;
                    utilityBar.setAttribute('data-rotating', true);
                    utilityBar.setAttribute('data-messages-count', currentMessagesCount + 1);
                    utilityBar.setAttribute('data-bundle-update-completed', true);
                    
                    let thirdMessage = `<div class="show-message" id="message3"><p>${window.Branch.cart.shipThresholdData.rotating_bundle_message}</p></div>`
                    utilityBar.querySelector('.utility-bar__main-message').insertAdjacentHTML('beforeend', thirdMessage)
                  }
                }
              }

                /* End update utility bar */

                var styleSheet = document.createElement("style");
                styleSheet.type = "text/css";
                styleSheet.innerText = '@keyframes progressBar { 0% { width: 0; } 100% { width: ' + widthPercentage + '%; }}';
                document.head.appendChild(styleSheet);

                document.querySelector('.cart-free-shipping span').style.animationName = 'progressBar';
            });

}

// Function to apply discount code via Shopify's discount URL to trigger proper line item splitting
function applyDiscountCodeToSplitItems(callback) {
  const discountCode = window.AUTO_DISCOUNT_CODE;
  if (!discountCode) {
    if (callback) callback();
    return;
  }

  // Fetch the discount URL to trigger Shopify's discount application logic
  fetch(`/discount/${discountCode}`, {
    method: 'GET',
    credentials: 'include',
    redirect: 'follow'
  })
  .then(response => {
    // Small delay to ensure Shopify has processed the discount before refreshing
    setTimeout(() => {
      if (callback) callback();
    }, 300);
  })
  .catch(error => {
    if (callback) callback();
  });
}
